/** A date from a stored timestamp, or null when it's missing or unparseable. */
export function toDate(d: Date | string | null | undefined): Date | null {
  if (!d) return null
  const date = d instanceof Date ? d : new Date(d)
  return Number.isNaN(date.getTime()) ? null : date
}
